export enum EDebounceTime {
    DEFAULT = 1000
}
